import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-3" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "row mb-2" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "text-danger fw-bold" }
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "row mb-2" }
const _hoisted_22 = { class: "col-md-9" }
const _hoisted_23 = {
  key: 1,
  class: "row mb-2"
}
const _hoisted_24 = { class: "col-md-9" }
const _hoisted_25 = { class: "row mb-2" }
const _hoisted_26 = { class: "col-md-9" }
const _hoisted_27 = {
  key: 2,
  class: "row mb-2"
}
const _hoisted_28 = { class: "col-md-9" }
const _hoisted_29 = {
  key: 3,
  class: "row mb-2"
}
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 4,
  class: "row mb-2"
}
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = ["value"]

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/clientesContratosService";
import {fdata, fdataUS,fdataUSS} from "@/utils/funcoes";

//componentes
import TrataTecla from "@/components/TrataTecla/Index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownPlanos from "@/components/Dropdowns/DropdownPlanos.vue";
import DropdownSimNao from "@/components/Dropdowns/DropdownSimNao.vue";
import DropdownContratosStatus from "@/components/Dropdowns/DropdownContratosStatus.vue";

interface IProps {
  EmpresaId?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpresasContratos',
  props: {
    EmpresaId: {}
  },
  setup(__props: any) {


//vue
var props = __props;

  var controle = reactive({
    empresaId: props.EmpresaId as number | null | undefined,
    itens: [] as service.Contrato[],
    listaStatus: [] as service.ContratoStatus[],
    model: {
      empresaId: props.EmpresaId
    } as service.Contrato,
    janela: false,
    janPergunta:false,
    erro: "",
    status: ""
  })

  onMounted(() => {
   
    buscarItems();

  });

  watch(() => props.EmpresaId, (newValue) => {
    controle.empresaId = newValue;
    controle.model.empresaId = newValue ?? 0;
    buscarItems();
  });

  async function buscarItems() {

      if (!props.EmpresaId) {
        controle.itens = [];
        return;
      }

      controle.status = "Buscando items...";
      controle.erro = "";
      service.obter({empresaId: props.EmpresaId} as service.Filtros)
      .then((r) => {
        controle.itens = r;
        controle.status = "";
      })
      .catch((error) => {
        controle.erro = `Erro ao buscar items: ${error}`;
        controle.status = "";
      });
  }
      
  async function buscarStatus() {

      controle.status = "Buscando status...";
      controle.erro = "";
      service.obterStatus()
      .then((r) => {
        controle.listaStatus = r;
        controle.status = "";
      })
      .catch((error) => {
        controle.erro = `Erro ao buscar items: ${error}`;
        controle.status = "";
      });
  }

  async function salvar() {

      controle.status = "Salvando item...";
      controle.erro = "";


      controle.model.empresaId = controle.empresaId ?? 0;

      service.salvar(controle.model)
      .then(() => {
        controle.status = "";
        controle.model = {
          empresaId: controle.model.empresaId,
          
        } as service.Contrato;
        buscarItems();
        controle.janela = false;
      })
      .catch((error) => {
        controle.erro = `Erro ao salvar item: ${error}`;
        controle.status = "";
      });
  }

  function excluir(item: service.Contrato) {
    controle.model = item;
    controle.janPergunta = true;
  }

  function excluirConfirma()
  {
    controle.janPergunta = false;
    controle.status = "Excluindo item...";
    controle.erro = "";

    service.excluir(controle.model.contratoId)
    .then(() => {
      controle.status = "";
      controle.model = {
        empresaId: controle.model.empresaId,

      } as service.Contrato;
      buscarItems();
    })
    .catch((error) => {
      controle.erro = `Erro ao excluir item: ${error}`;
      controle.status = "";
    });
  }

function adicionar(){

  controle.model = {
    empresaId: controle.empresaId,
    statusId: 1,
  } as service.Contrato;

  controle.janela = true;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "card-title" }, "Contratos")
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (adicionar()))
                }, "Adicionar")
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Contrato"),
                      _createElementVNode("th", null, "Vendedor"),
                      _createElementVNode("th", null, "Plano"),
                      _createElementVNode("th", null, "Status"),
                      _createElementVNode("th", null, "Pré contrato"),
                      _createElementVNode("th", null, "Dt. Inicio"),
                      _createElementVNode("th", null, "Dt. Fim"),
                      _createElementVNode("th", null, "Dt. Assinatura"),
                      _createElementVNode("th", null, "Ações")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(item.contratoId), 1),
                        _createElementVNode("td", null, _toDisplayString(item.vendedor?.nomeCompleto), 1),
                        _createElementVNode("td", null, _toDisplayString(item.plano.nome), 1),
                        _createElementVNode("td", null, _toDisplayString(item.status.descricao), 1),
                        _createElementVNode("td", null, _toDisplayString(item.preContrato == true ? 'Sim' : 'Não'), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataInicio)), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataFim)), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(fdata)(item.dataAssinatura)), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            class: "text-primary me-2",
                            title: "Alterar registro",
                            onClick: ($event: any) => {_unref(controle).model = item; _unref(controle).janela = true}
                          }, [...(_cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "flaticon-edit fs-5" }, null, -1)
                          ]))], 8, _hoisted_8),
                          _createElementVNode("a", {
                            class: "text-danger me-2",
                            title: "Excluir registro",
                            onClick: ($event: any) => (excluir(item))
                          }, [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "flaticon-delete fs-5" }, null, -1)
                          ]))], 8, _hoisted_9),
                          _createVNode(_component_RouterLink, {
                            class: "text-primary me-2",
                            title: "Ver o contrato",
                            target: "_blank",
                            to: { name: 'contratosVer', params: { id: item.contratoId } }
                          }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "flaticon-search fs-5" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]),
                          (item.dataAssinatura == null)
                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 0,
                                class: "text-primary",
                                title: "Assinar o contrato",
                                target: "_blank",
                                to: { name: 'contratosAssinar', params: { id: item.contratoId } }
                              }, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createElementVNode("i", { class: "flaticon-pen fs-5" }, null, -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, "Registros: " + _toDisplayString(_unref(controle).itens.length), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(controle).status), 1),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(controle).erro), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createVNode(MsgBox, {
          id: 'janAddContratos',
          class: "modal-md",
          "data-bs-backdrop": "static",
          exibir: _unref(controle).janela,
          titulo: 'Contrato da empresa',
          onOnFechou: _cache[7] || (_cache[7] = ($event: any) => (_unref(controle).janela = false)),
          "botao-gravar": true,
          "botao-fechar": true,
          onOnGravar: _cache[8] || (_cache[8] = ($event: any) => (salvar()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-3" }, " Pré contrato ", -1)),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(DropdownSimNao, {
                  modelValue: _unref(controle).model.preContrato,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).model.preContrato) = $event)),
                  class: "form-select form-select-sm"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_unref(controle).model.preContrato == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-3" }, " Vencimento 1º Boleto ", -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      value: _unref(fdataUS)(_unref(controle).model.dataPriParcela)
                    }, null, 8, _hoisted_20)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-md-3" }, " Plano ", -1)),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(DropdownPlanos, {
                  modelValue: _unref(controle).model.planoId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.planoId) = $event)),
                  class: "form-select form-select-sm"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_unref(controle).model.planoId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-3" }, null, -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_RouterLink, {
                      class: "btn btn-sm btn-primary",
                      title: "Ler o contrato",
                      target: "_blank",
                      to: { name: 'planosLer', params: { id: _unref(controle).model.planoId } }
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createElementVNode("i", { class: "flaticon-search" }, null, -1),
                        _createTextVNode(" Ler o contrato ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-3" }, " Vendedor ", -1)),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(DropdownVendedores, {
                  modelValue: _unref(controle).model.vendedorId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.vendedorId) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_unref(controle).model?.contratoId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-3" }, " Status ", -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(DropdownContratosStatus, {
                      modelValue: _unref(controle).model.statusId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.statusId) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(controle).model?.contratoId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-3" }, " Dt Inicio ", -1)),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      value: _unref(fdataUS)(_unref(controle).model.dataInicio),
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_unref(controle).model.dataInicio = $event.target.value))
                    }, null, 40, _hoisted_31)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(controle).model?.contratoId > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-md-3" }, " Dt Fim ", -1)),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      value: _unref(fdataUS)(_unref(controle).model.dataFim),
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_unref(controle).model.dataFim = $event.target.value))
                    }, null, 40, _hoisted_34)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["exibir"])
      ]),
      _: 1
    }),
    _createVNode(MsgBox, {
      id: 'janPergunta',
      class: "modal-md",
      "data-bs-backdrop": "static",
      exibir: _unref(controle).janPergunta,
      titulo: 'Atenção',
      onOnFechou: _cache[9] || (_cache[9] = ($event: any) => (_unref(controle).janPergunta = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[10] || (_cache[10] = ($event: any) => (excluirConfirma()))
    }, {
      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
        _createElementVNode("div", { class: "row mb-2" }, [
          _createElementVNode("div", { class: "col-md-12 fs-5 fw-bold text-center" }, " Deseja excluir este registro ? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})